import comSpSkeleton from "../../../../engines/components/comSpSkeleton";
import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { GeneralKind } from "../../../define/GeneralKind";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import openOreManager from "../../manager/openOreManager";
import { openOreEndInterface, openOreEventInterface, openOreStartInterface } from "./openOreConst";
import openOreGame from "./openOreGame";
const {ccclass, property} = cc._decorator;

@ccclass
export default class openOreGameObj extends cc.Component {

    @property({type:cc.Node,displayName:"石头图片"})
    showSp:cc.Node = null;

    @property({type:cc.Node,displayName:"切块图片"})
    pearlSp:cc.Node = null;

    @property({type:cc.Node,displayName:"物品图片"})
    objSp:cc.Node = null;

    @property({type:cc.Node,displayName:"价格的标"})
    priceNode:cc.Node = null;

    @property({type:cc.Node,displayName:"物品后面的光"})
    sprGoodsLight:cc.Node = null;

    startData:openOreStartInterface = null;

    gameScript:openOreGame = null;

    initPos:cc.Vec2 = null;

    canClick:boolean = true;

    isHaveBiao:boolean = false;

    openOreManager:openOreManager = null;

    openObjId:number = null;

    // private oPrice = 0;

    start(): void {
        this.initPos = this.node.getPosition().clone();
        this.sprGoodsLight.active = false;
    }

    onLoad(){
        this.node.on("touchend",this.onBtnClick,this);
    }

    bindDate(startData:openOreStartInterface,gameScript:openOreGame,isHaveBiao:boolean){
        this.openOreManager = NormalGameManager._instance.openOreManager;
        this.isHaveBiao = isHaveBiao;
        this.startData = startData;
        // this.oPrice = this.startData.price;
        // 倍率增长
        // this.startData.price = Math.floor( NormalGameManager._instance.getPriceRate() *  this.oPrice);
        this.gameScript = gameScript;
        this.loadIcon();
        this.updatePrice();
    }

    loadIcon(){
        let iconPath = this.startData.icon;
        if(iconPath){
            getOneBundleByInstant(BUNDLE_SMALL_NAME.openOreGameBundle).load(`openOreGameAssets/openOre/${iconPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载石头图片失败",err)
                    return;
                }
                this.showSp.getComponent(cc.Sprite).spriteFrame = asset;
                this.scheduleOnce(()=>{
                    this.node.width = this.showSp.width;
                    this.node.height = this.showSp.height;
                });
            });
        }
    }

    getNodeHeight() {
        return this.showSp.height;
    }

    updatePrice(){
        if(!this.canClick){
            this.priceNode.active = this.canClick;
            return;
        }
        this.priceNode.active = this.isHaveBiao;
        let priceLb:cc.Label = this.priceNode.getChildByName("label").getComponent(cc.Label);
        priceLb.string = data_control.getNumberFormat( this.startData.price );
    }

    onBtnClick(){
        if(this.canClick){
            O1HD.getManagers().soundMgr.playSound("anNiu");

            let price = this.startData.price;
            if(O1HD.getServices().userSrv.getCoins() < price){
                O1HD.getModules().uiControlModule.showMessageBox("钱不够");
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getModules().uiControlModule.showMessageBox("购买成功");

            // // 测试代码
            // console.log(`购买矿石 id = ${this.startData.id}`, '现价：'+price);

            let gameData = NormalGameManager._instance.getGameData();
            if (!gameData.bFirstBuyStore) {
                gameData.bFirstBuyStore = true;
                NormalGameManager._instance.writeGameData();
                NormalGameManager._instance.addOneWeChatTriggerLinkUnShift(GeneralKind.TriggerChatId.FIRST_BUY_STORE);
            }


            this.gameScript?.spliceOneSaveObj(this.node);
            O1HD.getServices().userSrv.setCoins(-price,true);

            let bindBackId = this.startData.bindBackId;
            NormalGameManager._instance.onPushGoods(bindBackId,1);

            this.gameScript.startCutObj(this.node);
            // this.gameScript?.startExplain(this.node);
        }
    }

    openOne(oneInterface:openOreEndInterface){
        let spPath:string = oneInterface.incision;
        let halfSpPath:string = spPath.substring(0,spPath.indexOf("切")+1);

        let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.openOreGameBundle);
        let pathAry:string[] = [
            `openOreGameAssets/openOre/${spPath}`,
            `openOreGameAssets/openOre/${halfSpPath}`
        ]
        bundle.load(pathAry,cc.SpriteFrame,(err,asset:cc.SpriteFrame[])=>{
            if(err){
                console.log("加载石头图片失败",err)
                return;
            }
            this.showSp.getComponent(cc.Sprite).spriteFrame = asset[0];
            this.pearlSp.getComponent(cc.Sprite).spriteFrame = asset[1];
        });
    }

    async openTwo(oneInterface:openOreEndInterface){
        this.pearlSp.getComponent(cc.Sprite).spriteFrame = null;
        let spPath:string = oneInterface.incision;
        let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.openOreGameBundle);
        bundle.load(`openOreGameAssets/openOre/${spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
            if(err){
                console.log(err,"加载石头完全切开图片失败");
                return;
            }
            this.showSp.getComponent(cc.Sprite).spriteFrame = asset;
        });
        let param = oneInterface.param;
        if(param != null){
            let backAry = param["backpackId"];
            if(backAry != null){
                let weightAry:number[] = [];
                for(let i =0;i<backAry.length;i++){
                    let back = backAry[i];
                    let weight:number = back.weight;
                    weightAry.push(weight);
                }
                let randIndex:number = data_control.getRandIPosByWeights(weightAry);
                if(!isNaN(randIndex)){
                    let back = backAry[randIndex];
                    let backConfig = backPackEventMap()[back?.backpackId];
                    // console.log(backConfig,"背包config",backAry[back],backAry[back]?.backpackId,weightAry,backAry,randIndex);
                    if(backConfig){
                        this.openObjId = backConfig.id;
                        let objPath:string = backConfig.spPath;
                        this.sprGoodsLight.active = true;
                        let iconPath = "backpackAssets/objSp/" + objPath;
                        let bundlePb = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
                        bundlePb.load(iconPath, cc.SpriteFrame
                            , (err,imgs:cc.SpriteFrame)=>
                            {
                                if(err){
                                    console.log(err);
                                }else{
                                    this.objSp.getComponent(cc.Sprite).spriteFrame = imgs;
                                }
                            }
                        );
                        // bundle.load(`openOreGameAssets/openOre/${objPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                        //     if(err){
                        //         console.log(err,"加载切石头物品图片失败",err);
                        //         return;
                        //     }
                        //     this.objSp.getComponent(cc.Sprite).spriteFrame = asset;
                        // });
                    }
                }
            }
        }
    }

}
